import { Box, styled } from '@mui/material';
import AppTheme from 'App.theme';

interface IDivider {
  $color?: string;
  $height?: string;
}

const color = ($color: string | undefined) => {
  if (!$color) {
    return null;
  }
  const [type, detail] = $color.split('.');
  if (!type || !detail) {
    return null;
  }
  // @ts-ignore
  return AppTheme.palette[type][detail];
};

const Divider = styled(Box, {
  shouldForwardProp: (prop: string) => !['$height', '$color'].includes(prop)
})<IDivider>`
  height: ${({ $height }) => $height || '1px'};
  background-color: ${({ theme, $color }) =>
    color($color) || $color || theme.palette.primary.main};
`;

export default Divider;
